export const getStack = (state) => {
  const { list } = state.notification
  return _.filter(
    _.map(
      list.items,
      (item, uid) => {
          return item
      }
    ),
    (item) => {
      return item.stacked
  }).sort((a, b) => {
    return b.created - a.created
  })
}

export const getStackItem = (state, uid) => {
  const { list } = state.notification
  return list.items[uid]
}

export const getItems = (state) => {
  const { list } = state.notification
  return _.map( list.items, (item, uid) => {
    return item
  }).sort((a, b) => {
    return b.created - a.created
  })
}

export const getItem = (state, uid) => {
  const { list } = state.notification
  return list.items[uid]
}



// WEBPACK FOOTER //
// ./src/app/react-redux/selectors/notification.js